import axios from "../../service";
import { DocumentService } from "../resources";

export const state = {
  selectStore: {},
  couponList: {
    report: [],
    total: 0
  }
};

export const mutations = {
  INIT_COUPON_LIST(state, newValue) {
    if (newValue.length == 0) {
      state.couponList.report = newValue;
      state.couponList.total = newValue.length;
    } else {
      for (let index = 0; index < newValue.report.length; index++) {
        if (newValue.report[index].email === null) {
          newValue.report[index].email = "-";
        }
        if (newValue.report[index].partner_name === null) {
          newValue.report[index].partner_name = "-";
        }
        newValue.report[index].used_amount =
          newValue.report[index].limit_amount -
          newValue.report[index].used_amount;
      }
      state.couponList = newValue;
    }
  },
  INIT_SETT_STORE_SELECT(state, newValue) {
    state.selectStore = newValue;
  }
};

export const getters = {};

export const actions = {
  async getTaxInvoice({ commit }, data) {
    try {
      let resp = await DocumentService.apiGetTaxInvoice(data);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async getTaxInvoiceByid({ commit }, id) {
    try {
      let resp = await DocumentService.apiGetTaxInvoiceByid(id);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async getTaxInvoiceByidDetail({ commit }, id) {
    try {
      let resp = await DocumentService.apiGetTaxInvoiceByidDetail(id);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async texInvoiceGetLink({ commit }, id) {
    try {
      let resp = await DocumentService.apiGetTexInvoiceGetLink(id);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async getPrintTaxinvoice({ commit }, id) {
    try {
      let resp = await DocumentService.apiGetPrintTaxinvoice(id)
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },


};
